module.exports = __webpack_public_path__ + "static/img/puzzlesmadia.2d0c9173.png";